<template>
  <div class="view-wrapper">
    <div class="view">
      <v-card>
        <v-card-title style="padding: 4px 16px">
          <h6>Фильтр</h6>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.startDate"
                  label="С"
                  type="date"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.endDate"
                  label="По"
                  type="date"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filter.tableId"
                  :items="tables"
                  label="Таблица"
                  item-text="tableNameRu"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filter.userId"
                  :items="users"
                  label="Пользователь"
                  item-text="label"
                  item-value="id"
                  :filter="userFilter"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <div>{{ item.name }} ({{ item.userName }})</div>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span>{{ item.name }} ({{ item.userName }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filter.changedData"
                  label="Измененные данные"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isInsuredTable" dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.insuredCardNo"
                  label="Номер карты"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.insuredFullName"
                  label="ФИО"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.insuredIin"
                  label="ИИН"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isContractsTable" dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.contractNumber"
                  label="Номер контракта"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.contractInsuredCardNo"
                  label="Номер карты застрахованного"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isInvoiceServicesTable" dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.invoiceServiceCheckNumber"
                  label="Рег. номер"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filter.invoiceServiceInsuredCardNo"
                  label="Номер карты застрахованного"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="applyFilter">Применить</v-btn>
          <v-btn small @click="resetFilter">Сбросить</v-btn>
        </v-card-actions>
      </v-card>

      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="pageSize"
        hide-default-footer
        item-key="id"
        fixed-header
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
      >
        <template v-slot:item.changedAt="{ item }">
          <span>{{ formatDateTime(item.changedAt) }}</span>
        </template>
        <template v-slot:item.operation="{ item }">
          <span>{{ operationLabel(item.operation) }}</span>
        </template>
        <template v-slot:item.changedByName="{ item }">
          <span>{{ userLabel(item) }}</span>
        </template>
        <template v-slot:item.changedFields="{ item }">
          <v-btn
            v-if="item.changedFields && item.changedFields.length > 0"
            icon
            small
            @click="openChanges(item)"
          >
            <v-icon small>more_horiz</v-icon>
          </v-btn>
          <span v-else>-</span>
        </template>
      </v-data-table>

      <div class="logs-pagination">
        <span class="logs-pagination__info">
          {{ recordsRangeText }} · Страница {{ page }} из {{ totalPages }}
        </span>
        <div class="logs-pagination__controls">
          <v-btn
            icon
            small
            :disabled="page <= 1 || loading"
            @click="goToPage(page - 1)"
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            :disabled="page >= totalPages || loading"
            @click="goToPage(page + 1)"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog v-model="changesDialog" max-width="900px">
      <v-card>
        <v-card-title>
          Измененные поля
          <v-spacer></v-spacer>
          <v-btn icon @click="changesDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Поле</th>
                <th>Старое значение</th>
                <th>Новое значение</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(change, idx) in selectedChanges" :key="idx">
                <td>{{ change.fieldNameRu || change.fieldName }}</td>
                <td>{{ change.oldValue }}</td>
                <td>{{ change.newValue }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fetch from "@/utils/fetch";
import vm2js from "@/utils/vm2js";
import dateIsoFilter from "@/filters/dateIso.filter";
import moment from "moment";

let Filter = function() {
  let self = this;
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  self.startDate = dateIsoFilter(startDate);
  self.endDate = dateIsoFilter(new Date());
  self.tableId = null;
  self.userId = null;
  self.changedData = "";
  self.insuredCardNo = "";
  self.insuredFullName = "";
  self.insuredIin = "";
  self.contractNumber = "";
  self.contractInsuredCardNo = "";
  self.invoiceServiceCheckNumber = "";
  self.invoiceServiceInsuredCardNo = "";
};

export default {
  data: () => ({
    filter: new Filter(),
    loading: false,
    items: [],
    tables: [],
    users: [],
    changesDialog: false,
    selectedChanges: [],
    page: 1,
    pageSize: 25,
    totalElements: 0,
    headers: [
      { text: "Дата", value: "changedAt" },
      { text: "Таблица", value: "tableNameRu" },
      { text: "Операция", value: "operation" },
      { text: "Пользователь", value: "changedByName" },
      { text: "ID записи", value: "rowId" },
      { text: "Измененные данные", value: "changedFields", sortable: false }
    ]
  }),
  computed: {
    selectedTable() {
      if (!this.filter.tableId) return null;
      return this.tables.find(t => t.id === this.filter.tableId) || null;
    },
    isInsuredTable() {
      return this.selectedTable?.tableName === "insurance_insured";
    },
    isContractsTable() {
      return this.selectedTable?.tableName === "insurance_contracts";
    },
    isInvoiceServicesTable() {
      return this.selectedTable?.tableName === "accounting_invoices_services";
    },
    totalPages() {
      if (!this.totalElements) return 1;
      return Math.max(1, Math.ceil(this.totalElements / this.pageSize));
    },
    recordsRangeText() {
      if (!this.totalElements) {
        return "0 из 0";
      }
      const from = (this.page - 1) * this.pageSize + 1;
      const to = Math.min(this.page * this.pageSize, this.totalElements);
      return `${from}-${to} из ${this.totalElements}`;
    }
  },
  watch: {
    "filter.tableId"() {
      this.filter.insuredCardNo = "";
      this.filter.insuredFullName = "";
      this.filter.insuredIin = "";
      this.filter.contractNumber = "";
      this.filter.contractInsuredCardNo = "";
      this.filter.invoiceServiceCheckNumber = "";
      this.filter.invoiceServiceInsuredCardNo = "";
    }
  },
  methods: {
    formatDateTime(value) {
      if (!value) return "";
      return moment(value).format("DD.MM.YYYY HH:mm:ss");
    },
    operationLabel(operation) {
      if (operation === "INSERT") return "Создание";
      if (operation === "UPDATE") return "Изменение";
      if (operation === "DELETE") return "Удаление";
      return operation;
    },
    userLabel(item) {
      if (item.changedByName && item.changedByUserName) {
        return `${item.changedByName} (${item.changedByUserName})`;
      }
      return item.changedByName || item.changedByUserName || "";
    },
    userFilter(item, queryText) {
      const q = (queryText || "").toLowerCase().trim();
      if (!q) return true;
      const name = (item.name || "").toLowerCase();
      const userName = (item.userName || "").toLowerCase();
      const label = (item.label || "").toLowerCase();
      return name.includes(q) || userName.includes(q) || label.includes(q);
    },
    openChanges(item) {
      this.selectedChanges = item.changedFields || [];
      this.changesDialog = true;
    },
    applyFilter() {
      this.goToPage(1);
    },
    resetFilter() {
      this.filter = new Filter();
      this.goToPage(1);
    },
    goToPage(page) {
      const next = Math.min(Math.max(page || 1, 1), this.totalPages);
      this.page = next;
      this.fetchItems();
    },
    async fetchUsers() {
      const users = await fetch.get("/api/auth/get-list");
      this.users = Array.isArray(users)
        ? users.map(u => ({
            ...u,
            label: `${u.name || ""} (${u.userName || ""})`
          }))
        : [];
    },
    async fetchItems() {
      this.loading = true;
      try {
        const payload = {
          ...vm2js(this.filter),
          page: Math.max(this.page - 1, 0),
          size: this.pageSize
        };
        const response = await fetch.post("/api/audit-log/get", payload);
        this.items = Array.isArray(response?.rows) ? response.rows : [];
        this.tables = Array.isArray(response?.tables) ? response.tables : [];
        this.totalElements = response?.totalElements || 0;
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    await Promise.all([this.fetchUsers(), this.fetchItems()]);
  }
};
</script>

<style scoped>
.logs-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 12px 12px;
}

.logs-pagination__info {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.logs-pagination__controls {
  display: flex;
  align-items: center;
}
</style>
